exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.valid-error .ant-select-selection__placeholder[data-v-5db63df4]{\n  color: #f5222d;\n}\n", ""]);

// exports
